import React from 'react'
import { Box, Grid, Text } from '@mantine/core'
import ItemWrapper from '../../../components/ItemWrapper'
import LabeledTitle from '../../../components/LabeledTitle'
import { CompanyItem } from './types'
import { useTheme } from '../../../components/ThemeProvider'

interface CompanySummaryProps {
  companies: CompanyItem[]
}

const CompanySummary: React.FC<CompanySummaryProps> = ({ companies }) => {
  const theme = useTheme()
  const totalCount = companies.length
  const activeCount = companies.filter((c) => c.basicInfo.regStatus === '存续').length
  const relationshipTypes = Array.from(new Set(companies.flatMap((c) => c.relationship))).length
  const regions = Array.from(new Set(companies.map((c) => c.basicInfo.base).filter(Boolean))).length

  const hasStockholderInfo = companies.filter((c) => c.stockholder).length
  const averageInvestRate =
    companies
      .filter((c) => c.stockholder?.investRate)
      .reduce((sum, c) => {
        const rate = parseFloat(c.stockholder.investRate.replace('%', ''))
        return sum + (isNaN(rate) ? 0 : rate)
      }, 0) / Math.max(hasStockholderInfo, 1)

  const cardBackgroundColor = '#ffffff'

  return (
    <ItemWrapper>
      <LabeledTitle title="关联企业概览" />
      <Grid gutter="md">
        <Grid.Col span={3}>
          <Box
            ta="center"
            p="md"
            style={{
              backgroundColor: cardBackgroundColor,
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            }}
          >
            <Text size="xl" fw={700} style={{ color: theme?.primaryColor || '#1c7ed6' }}>
              {totalCount}
            </Text>
            <Text size="sm" c="dimmed">
              关联企业总数
            </Text>
          </Box>
        </Grid.Col>
        <Grid.Col span={3}>
          <Box
            ta="center"
            p="md"
            style={{
              backgroundColor: cardBackgroundColor,
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            }}
          >
            <Text size="xl" fw={700} style={{ color: theme?.primaryColor || '#22c55e' }}>
              {activeCount}
            </Text>
            <Text size="sm" c="dimmed">
              存续企业数
            </Text>
          </Box>
        </Grid.Col>
        <Grid.Col span={3}>
          <Box
            ta="center"
            p="md"
            style={{
              backgroundColor: cardBackgroundColor,
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            }}
          >
            <Text size="xl" fw={700} style={{ color: theme?.primaryColor || '#a855f7' }}>
              {relationshipTypes}
            </Text>
            <Text size="sm" c="dimmed">
              关联类型数
            </Text>
          </Box>
        </Grid.Col>
        <Grid.Col span={3}>
          <Box
            ta="center"
            p="md"
            style={{
              backgroundColor: cardBackgroundColor,
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            }}
          >
            <Text size="xl" fw={700} style={{ color: theme?.primaryColor || '#f97316' }}>
              {regions}
            </Text>
            <Text size="sm" c="dimmed">
              涉及地区数
            </Text>
          </Box>
        </Grid.Col>
        {hasStockholderInfo > 0 && (
          <>
            <Grid.Col span={6}>
              <Box
                ta="center"
                p="md"
                style={{
                  backgroundColor: cardBackgroundColor,
                  borderRadius: '8px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                }}
              >
                <Text size="xl" fw={700} style={{ color: theme?.primaryColor || '#06b6d4' }}>
                  {hasStockholderInfo}
                </Text>
                <Text size="sm" c="dimmed">
                  有持股信息企业
                </Text>
              </Box>
            </Grid.Col>
            <Grid.Col span={6}>
              <Box
                ta="center"
                p="md"
                style={{
                  backgroundColor: cardBackgroundColor,
                  borderRadius: '8px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                }}
              >
                <Text size="xl" fw={700} style={{ color: theme?.primaryColor || '#8b5cf6' }}>
                  {averageInvestRate.toFixed(2)}%
                </Text>
                <Text size="sm" c="dimmed">
                  平均持股比例
                </Text>
              </Box>
            </Grid.Col>
          </>
        )}
      </Grid>
    </ItemWrapper>
  )
}

export default CompanySummary
